import { Heading } from '../common/heading';

export const UsefullToolsSection = ({ SECTION_TOOLS, headerClass }) => (
  <div className="lil-container lil-py-24 sm:lil-py-12">
    <Heading title="Useful tools and calculators" titleClass={headerClass} />
    <div className="lil-flex lil-flex-wrap">
      {SECTION_TOOLS.map((ele, index) => {
        return (
          <div className="lil-pr-6 lil-w-1/4 sm:lil-w-1/2 lil-mt-5" key={index}>
            <a href={ele.link}>
              <div className="lil-bg-blue-50 lil-flex sm:lil-flex-col lil-items-center lil-px-4 lil-py-5 lil-rounded-xl lil-w-full sm:lil-h-32 sm:lil-text-center">
                <img src={ele.icon} alt="" className="lil-h-10" />
                <p className="lil-text-base lil-text-font-500 xl:lil-ml-3 sm:lil-text-base sm:lil-mt-2">
                  {ele.title}
                </p>
              </div>
            </a>
          </div>
        );
      })}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/usefulTools.tsx